import produce from 'immer';

// TYPES
import { Types, ConsultarUmaFuncionalidade } from './types';
import { ReducerActionRotaSP } from '../../../../../types';

export const INITIAL_STATE: ConsultarUmaFuncionalidade = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ConsultarUmaFuncionalidade {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_UMA_FUNCIONALIDADE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;

				break;
			}

			case Types.CONSULTAR_UMA_FUNCIONALIDADE_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;

				break;
			}

			case Types.CONSULTAR_UMA_FUNCIONALIDADE_FAILURE: {
				draft.status = 400;

				break;
			}

			case Types.CONSULTAR_UMA_FUNCIONALIDADE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;

				break;
			}

			default:
		}
	});
}
